import { useEffect, useState } from "react";
import { MapPin, Search } from "lucide-react";
import { searchCity, saveCity } from "@/lib/weather";

export function CitySearch({ onDone }) {
  const [q, setQ] = useState("");
  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (q.trim().length < 3) { setResults([]); return; }
    setLoading(true);
    const t = setTimeout(() => {
      searchCity(q.trim()).then((r) => setResults(r.results || [])).catch(() => setResults([])).finally(() => setLoading(false));
    }, 450);
    return () => clearTimeout(t);
  }, [q]);

  return (
    <div data-testid="city-search" className="w-full max-w-md">
      <div className="flex items-center gap-2 bg-surfaceSecondary border border-hair rounded-full px-4 py-2 focus-within:border-brand">
        <Search size={15} className="text-subtle" />
        <input
          autoFocus
          data-testid="city-search-input"
          value={q}
          onChange={(e) => setQ(e.target.value)}
          placeholder="Cerca la tua città…"
          className="flex-1 bg-transparent text-base sm:text-sm text-onSurface placeholder:text-subtle focus:outline-none"
        />
      </div>
      {loading && <p className="mt-2 text-xs text-subtle">Cerco…</p>}
      {!!results.length && (
        <ul className="mt-2 border border-hair rounded-xl overflow-hidden bg-surface">
          {results.map((c, i) => (
            <li key={`${c.name}-${c.lat}`}>
              <button
                type="button"
                data-testid={`city-result-${i}`}
                onClick={() => { saveCity(c); onDone?.(); }}
                className="w-full flex items-center gap-2 px-4 py-2.5 text-left text-sm hover:bg-surfaceSecondary transition-colors"
              >
                <MapPin size={14} className="text-brand shrink-0" />
                <span className="font-semibold text-onSurface">{c.name}</span>
                <span className="text-subtle truncate">{c.region}</span>
              </button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
